import { requests } from '../../helper/agent';
import { SubmissionError } from 'redux-form';
import {
  HOSPITAL_LIST_REQUEST,
  HOSPITAL_LIST_RECEIVED,
  HOSPITAL_LIST_ERROR,
  HOSPITAL_LIST_SET_PAGE,
  //  HOSPITAL_LIST_CLEAR_FILTERS, HOSPITAL_LIST_SET_FILTERS,
  HOSPITAL_LIST_UNLOAD,
  HOSPITAL_SINGLE_UPDATED,
  HOSPITAL_SINGLE_UPDATE_REQUEST,
  HOSPITAL_SINGLE_CREATE_SUCCESS,
  HOSPITAL_SINGLE_CREATE_REQUEST,
  HOSPITAL_SINGLE_FETCH_REQUEST,
  HOSPITAL_SINGLE_FETCH_SUCCESS,
  HOSPITAL_SINGLE_DELETE_REQUEST,
  HOSPITAL_SINGLE_DELETE_SUCCESS,
  HOSPITAL_SINGLE_CREATE_ERROR,
} from '../constants';

import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { parseApiErrors } from '../../helper/apiUtils';

export const hospitalListRequest = () => ({
  type: HOSPITAL_LIST_REQUEST,
});

export const hospitalListReceived = (data) => ({
  type: HOSPITAL_LIST_RECEIVED,
  data,
});

export const hospitalListError = (error) => ({
  type: HOSPITAL_LIST_ERROR,
  error,
});

export const hospitalListSetPage = (page) => ({
  type: HOSPITAL_LIST_SET_PAGE,
  page,
});
//
//export const hospitalListSetFilters = (filters) => ({
//  type: HOSPITAL_LIST_SET_FILTERS,
//  filters,
//});
//
//export const hospitalListClearFilters = () => ({
//  type: HOSPITAL_LIST_CLEAR_FILTERS,
//});

export const hospitalListUnload = () => ({
  type: HOSPITAL_LIST_UNLOAD,
});

export const hospitalListFetch = (page = 1, filters = {}, endPoint = API_ROUTES.HOSPITALS) => {
  return (dispatch) => {
    dispatch(hospitalListRequest());
    //console.log('Fetching hospitals ...');
    filters.page = page;
    if (filters.pagination === undefined) {
      filters.pagination = true;
    }
    return requests
      .get(endPoint, filters)
      .then((response) => dispatch(hospitalListReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(hospitalListError(error));
      });
  };
};

export const hospitalSingleUpdateRequest = () => ({
  type: HOSPITAL_SINGLE_UPDATE_REQUEST,
});

export const hospitalSingleUpdated = (data) => ({
  type: HOSPITAL_SINGLE_UPDATED,
  data,
});

export const hospitalSingleUpdate = (data, hospitalId) => {
  return (dispatch) => {
    dispatch(hospitalSingleUpdateRequest());
    return requests
      .patch(`${API_ROUTES.HOSPITALS}/${hospitalId}`, data)
      .then((response) => dispatch(hospitalSingleUpdated(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

export const hospitalSingleCreateRequest = () => ({
  type: HOSPITAL_SINGLE_CREATE_REQUEST,
});

export const hospitalSingleCreateSuccess = (data) => ({
  type: HOSPITAL_SINGLE_CREATE_SUCCESS,
  data,
});

export const hospitalSingleCreateError = (error) => ({
  type: HOSPITAL_SINGLE_CREATE_ERROR,
  error,
});

export const hospitalSingleCreate = (data) => {
  return (dispatch) => {
    dispatch(hospitalSingleCreateRequest());
    return requests
      .post(`${API_ROUTES.HOSPITALS}`, data)
      .then((response) => {
        dispatch(hospitalSingleCreateSuccess(response));
        return response;
      })
      .catch((error) => {
        dispatch(hospitalSingleCreateError(error));
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

// FETCH SINGLE HOSPITAL
export const hospitalSingleFetchRequest = () => ({
  type: HOSPITAL_SINGLE_FETCH_REQUEST,
});

export const hospitalSingleFetchSuccess = (data) => ({
  type: HOSPITAL_SINGLE_FETCH_SUCCESS,
  data,
});

export const hospitalSingleFetch = (hospitalId) => {
  return (dispatch) => {
    dispatch(hospitalSingleFetchRequest());
    return requests
      .get(`${API_ROUTES.HOSPITALS}/${hospitalId}`)
      .then((response) => {
        dispatch(hospitalSingleFetchSuccess(response));
        return response;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

// DELETE HOSPITAL
export const hospitalSingleDeleteRequest = () => ({
  type: HOSPITAL_SINGLE_DELETE_REQUEST,
});

export const hospitalSingleDeleteSuccess = (hospitalId) => ({
  type: HOSPITAL_SINGLE_DELETE_SUCCESS,
  hospitalId,
});

export const hospitalSingleDelete = (hospitalId) => {
  return (dispatch) => {
    dispatch(hospitalSingleDeleteRequest());
    return requests
      .delete(`${API_ROUTES.HOSPITALS}/${hospitalId}`)
      .then(() => {
        dispatch(hospitalSingleDeleteSuccess(hospitalId));
        return hospitalId;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          throw new SubmissionError(parseApiErrors(error));
        } else if (error.response && error.response.status === 409) {
          throw new SubmissionError(parseApiErrors(error));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

// HOSPITAL CONTACT RECORD ACTIONS

export const hospitalContactRecordAdd = (hospitalId, contactData) => {
  return (dispatch) => {
    return requests
      .post(API_ROUTES.CONTACT_RECORDS, {
        ...contactData,
        hospital: `${API_ROUTES.HOSPITALS}/${hospitalId}`,
        contactRecordType: contactData.contactRecordType['@id'] || `/contact_record_types/${contactData.contactRecordType.id}`,
        // Ensure hospital-specific constraints
        notifyByMobile: false, // Always false for hospital contacts
        isInitialInvoice: contactData.isInitialInvoice || false,
        isChaseToContact: contactData.isChaseToContact || false,
        isDisabled: contactData.isDisabled !== undefined ? contactData.isDisabled : true,
      })
      .then((response) => {
        // Refresh hospital data to get updated contact records
        dispatch(hospitalSingleFetch(hospitalId));
        return response;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

export const hospitalContactRecordUpdate = (contactRecord, contactId) => {
  return (dispatch) => {
    return requests
      .patch(`${API_ROUTES.CONTACT_RECORDS}/${contactId}`, {
        ...contactRecord,
        contactRecordType: contactRecord.contactRecordType['@id'] || `/contact_record_types/${contactRecord.contactRecordType.id}`,
        // Enforce hospital-specific constraints
        notifyByMobile: false, // Always false for hospital contacts
      })
      .then((response) => {
        //        console.log('Updated contact record', response);
        dispatch(hospitalSingleFetch(response.hospital.id));
        return response;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

export const hospitalContactRecordRemove = (contactId, hospitalId) => {
  return (dispatch) => {
    return requests
      .delete(`${API_ROUTES.CONTACT_RECORDS}/${contactId}`)
      .then(() => {
        // Refresh hospital data to update contact records list
        dispatch(hospitalSingleFetch(hospitalId));
        return contactId;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};
